// @flow
/**
 * Сервис для работы с токеном авторизации
 */
export class AuthToken {
    /**
     * Ключ, под которым хранится токен пользователя в LocalStorage
     */
    _tokenLSKey: string;

    /**
     * @param tokenLSKey Ключ, под которым хранится токен пользователя в LocalStorage
     */
    constructor(tokenLSKey: string) {
        this._tokenLSKey = tokenLSKey;
    }

    /**
     * Возвращает токен
     * @returns Токен
     */
    get() {
        return localStorage.getItem(this._tokenLSKey);
    }

    /**
     * Устанавливает токен
     * @param token токен
     */
    set(token: string) {
        localStorage.setItem(this._tokenLSKey, token);
    }

    /**
     * Удаляет токен
     */
    remove() {
        localStorage.removeItem(this._tokenLSKey);
    }
}
